import { render, staticRenderFns } from "./PolicyLinkGenerationForm.vue?vue&type=template&id=1040d37c&"
import script from "./PolicyLinkGenerationForm.vue?vue&type=script&lang=js&"
export * from "./PolicyLinkGenerationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports